import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgGlobeGlyph from './svgs/GlobeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var globeGlyph = (props => useIcon(SvgGlobeGlyph, SvgGlobeGlyph, props));

export { globeGlyph as default };
